export default {
    getStoredExcuseById: (state) => (id) => {
        const excuse = state.excuses.find(excuse => excuse.id === id)
        if (excuse === undefined) {
            state.excuses.push({ id: id })
            return state.excuses.find(excuse => excuse.id === id)
        } else {
            return excuse
        }
    },
    getStoredExcusesByPage: (state) => (page = 1) => {
        if (isNaN(page)) {
            page = 1
        }
        return state.excuses.filter(excuse => excuse.page === page)
    },
    getStoredExcusesToday: state => {
        return state.excuses_today
    },
    getExcusePages: state => {
        return state.excuse_pages
    },
    getExcusesTodayStatus: state => {
        return state.excuses_today_status
    }
}
